export default __webpack_public_path__ + "static/media/story_shimadu-1.505e172b.png";